import { IServicePartner } from "src/types/ServicePartner";

interface FetchServicePartnerSelectorParams {
  postalCode: string;
  streetNumber: string;
  fetchData: (params: {
    endpoint: string;
    queryParameters: Record<string, any>;
  }) => Promise<{ data: IServicePartner[] }>;
}

export const fetchServicePartnerSelector = async ({
  postalCode,
  streetNumber,
  fetchData,
}: FetchServicePartnerSelectorParams): Promise<IServicePartner[]> => {
  try {
    const response = await fetchData({
      endpoint: "service-partners/selector",
      queryParameters: {
        country: "NL",
        postalCode,
        streetNumber,
      },
    });

    if (response && response.data) {
      return response.data;
    } else {
      throw new Error("Geen service partners gevonden");
    }
  } catch (err: unknown) {
    console.error("Error fetching service partners:", err);
    throw new Error("Error service partners gevonden");
  }
};
